import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { BannerMessage } from '../bannerMessage/BannerMessage';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import { DocAssistantCaptureContext, CAPTURE_STATUS } from './DocAssistantCaptureContext';

import './AssignWithAce.scss';

const AssignWithAce = () => {
  const enabled = useSelector((state) => state.mail.settings?.docAssistant?.enabled);
  const onDemand = useSelector((state) => state.mail.settings?.docAssistant?.onDemand);
  const isComposingEmail = useSelector((state) => state.mail.isComposingEmail);
  const { status, banner, startCapture, dismissBanner } = useContext(DocAssistantCaptureContext);

  // On Demand gates the button independently of Automatic processing; hidden while composing.
  if (!enabled || !onDemand || isComposingEmail) {
    return null;
  }

  // 'matched' navigates away from this view, but keep the button disabled until the poll fully settles,
  // since a new capture would cancel the post-assign refreshes.
  const searching = [CAPTURE_STATUS.SEARCHING, CAPTURE_STATUS.MATCHED, CAPTURE_STATUS.SETTLING].includes(status);

  return (
    <div className='assign-with-ace'>
      {banner && (
        <div data-testid='da-assign-failure-banner'>
          <BannerMessage displayBanner closeBanner={dismissBanner}>
            {banner}
          </BannerMessage>
        </div>
      )}
      <button
        className='assign-with-ace-button'
        data-testid='da-assign-with-ace-button'
        disabled={searching}
        onClick={startCapture}
      >
        {/* The icon renders in an <object>, so the :disabled stylesheet cannot recolor it. */}
        <Svg className='assign-with-ace-icon' data='/assets/sparkle.svg' fill={searching ? colors.disabledGrey : colors.strongBlue} />
        Assign with ACE
      </button>
    </div>
  );
};

export default AssignWithAce;
